import { ROUTES } from '../../../constants/routes';
import Reveal from '../../common/Reveal';
import ViewAllButton from '../shared/ViewAllButton';
import CourseCard from './CourseCard';

const MAX_COURSES = 6;

function CoursesSection({ courses, loading }) {
  const list = (courses || []).slice(0, MAX_COURSES);

  return (
    <section className="bg-[#1B1B1B] px-4 py-10 sm:px-6 sm:py-10 lg:px-8 lg:py-10">
      <div className="mx-auto max-w-7xl">
        <Reveal variant="up">
          <h2 className="text-2xl font-semibold text-white sm:text-3xl lg:text-[32px] xl:text-[36px]">New Launched Courses</h2>
        </Reveal>

        {loading && !courses?.length ? (
          <ul className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-6">
            {Array.from({ length: MAX_COURSES }, (_, i) => (
              <li key={i} className="h-80 animate-pulse rounded-2xl bg-white/10" />
            ))}
          </ul>
        ) : list.length > 0 ? (
          <ul className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-6">
            {list.map((course, index) => (
              <li key={course.id} className="h-full">
                <Reveal variant="zoom" delay={(index % 3) * 100} className="h-full">
                  <CourseCard course={course} hoverEnroll />
                </Reveal>
              </li>
            ))}
          </ul>
        ) : (
          <p className="mt-8 text-center text-gray-400">No new courses available.</p>
        )}

        <Reveal variant="up" delay={120}>
          <div className="mt-10 flex justify-center sm:mt-12">
            <ViewAllButton label="View All Courses" variant="dark" to={ROUTES.NEW_COURSES} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default CoursesSection;
